import { createClient } from '@supabase/supabase-js';

// Credenziali lette da .env (Vite: prefisso VITE_ obbligatorio)
// Il file .env NON va committato su git (è in .gitignore)
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  throw new Error('Missing Supabase variables. Crea il file .env con VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY');
}

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  },
  db: {
    schema: 'public',
  },
  global: {
    headers: { 'x-my-custom-header': 'tap2order' },
  },
});

// Password admin letta da variabile d'ambiente Vite
// NOTA: con VITE_ la variabile è inclusa nel bundle JS compilato (visibile con DevTools)
// ma è rimossa dal codice sorgente e dal repo git — obiettivo principale raggiunto.
export const ADMIN_PASSWORD = import.meta.env.VITE_ADMIN_PASSWORD || '';